<form [formGroup]="form" class="flex flex-col gap-[16px] w-full">
  <div class="flex flex-col">
    <label class="block text-[14px] fg-noir-2 text-600 font-semibold mb-2">
      {{ 'login.identifier_label' | translate }}
    </label>
    <input
      type="text"
      formControlName="identifier"
      autocomplete="email"
      placeholder="{{ 'login.identifier_placeholder' | translate }}"
      class="text-black w-full h-[58px] px-4 py-3 border border-gris-1-300 rounded-lg shadow-sm placeholder-gris-1-400"
      [class.border-red-500]="
        (form.controls.identifier.invalid && form.controls.identifier.touched) ||
        credentialsRejected()
      "
    />
  </div>

  <div class="flex flex-col">
    <label class="block text-[14px] fg-noir-2 text-600 font-semibold mb-2">
      {{ 'login.password_label' | translate }}
    </label>
    <input
      type="password"
      formControlName="password"
      autocomplete="current-password"
      placeholder="{{ 'login.password_placeholder' | translate }}"
      class="text-black w-full h-[58px] px-4 py-3 border border-gris-1-300 rounded-lg shadow-sm placeholder-gris-1-400"
      [class.border-red-500]="
        (form.controls.password.invalid && form.controls.password.touched) ||
        credentialsRejected()
      "
    />
  </div>
</form>
